<template>
  <div class="rule_btn" @click="toRule">
    <div class="icon">
      <img
        :src="data && data.buttonImage ? data.buttonImage : imageObj.rule_btn"
      />
    </div>
  </div>
</template>

<script>
import { getUrlParam } from '@/utils';
const imageObj = {
  rule_btn: require('../../assets/images/rule_btn_icon.png')
};
export default {
  data() {
    return {
      imageObj
    };
  },
  props: ['data'],
  computed: {
    user_type() {
      return getUrlParam('u') == '1' ? 'user' : 'driver';
    }
  },
  methods: {
    toRule() {
      this.trackLog('我的规则', true, {
        actEventType: 'invited_rule_click'
      });
      console.log(this.$route.query);
      this.$router.push({
        path: '/rule',
        query: {
          ...this.$route.query,
          user_type: this.user_type
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.rule_btn {
  // position: absolute;
  // top: 99px;
  // right: 21px;
  color: #fff;
  font-size: 24px;
  text-align: center;
  .fcc;
  img {
    width: 88px;
    height: auto;
  }
}
</style>
